import { forwardRef } from "react";
import classNames from "classnames";
import { AnimatePresence } from "framer-motion";
import { withClickOutside } from "../../../../hoc/withClickOutside";
import MechanicMenu from "../../MechanicMenu/MechanicMenu";
import dropdownArrow from "../../../../../assets/icons/dropdown_arrow.svg";
import userIcon from "../../../../../assets/images/user.png";
import classes from "./MyAccount.module.css";

const MyAccount = forwardRef((props, ref) => {
  const { open, setOpen } = props;

  const mechanicMenuToggleHandler = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const menuClosedHandler = () => {
    setOpen(false);
  };

  return (
    <div className={classNames(classes["my-account"])} ref={ref}>
      <button
        className={classes["my-account__btn"]}
        onClick={mechanicMenuToggleHandler}
      >
        <div
          className={classNames(
            "flex items-center",
            classes["my-account__icons"]
          )}
        >
          <img
            src={dropdownArrow}
            alt="dropdown arrow"
            className={classNames(
              classes["my-account__icon"],
              classes["my-account__arrow-icon"]
            )}
          />
          <img
            src={userIcon}
            alt="user"
            className={classNames(
              classes["my-account__icon"],
              classes["my-account__user-icon"]
            )}
          />
        </div>
        <span className={classes["my-account__text"]}>حسابي</span>
      </button>
      <AnimatePresence>
        {open && <MechanicMenu close={menuClosedHandler} />}
      </AnimatePresence>
    </div>
  );
});

export default withClickOutside(MyAccount);
